import { dataTypeForSelect, genderType } from "redux/commonTypes";
import { dialogType } from "../messages/messagesTypes";
import { galleryTypes } from "../photos/photosTypes";

export const actionTypes = {
  FETCH_ME: "PROFILE:FETCH_ME",
  SET_ME: "PROFILE:SET_ME",
  SET_BIRTH_DATE: "PROFILE:SET_BIRTH_DATE",
  SET_NAME: "PROFILE:SET_NAME",
  SET_CITY: "PROFILE:SET_CITY",
  SET_COUNTRY: "PROFILE:SET_COUNTRY",
  SET_GENDER: "PROFILE:SET_GENDER",
  SET_INTERESTED_GENDER: "PROFILE:SET_INTERESTED_GENDER",
  SET_EMAIL: "PROFILE:SET_EMAIL",
  RESET_ALL_PROFILE: "PROFILE:RESET_ALL",
  SET_EDIT_SUCCESS: "PROFILE:SET_EDIT_SUCCESS",
  SET_PROFILE_LOADING: "PROFILE:SET_PROFILE_LOADING",
  SET_PUBLIC_PHOTOS: "PROFILE:SET_PUBLIC_PHOTOS",
  SET_PRIVATE_PHOTOS: "PROFILE:SET_PRIVATE_PHOTOS",
  SET_AVATAR: "PROFILE:SET_AVATAR",
  SET_VARIABILITY_BIRTHDAY: "PROFILE:SET_VARIABILITY_BIRTHDAY",
  SET_VARIABILITY_NAME: "PROFILE:SET_VARIABILITY_NAME",
  SET_PROFILE_EXTENDED: "PROFILE:SET_PROFILE_EXTENDED",
  SET_NOT_VERIFIED: "PROFILE:SET_NOT_VERIFIED",
  SET_NOT_HAVE_PHOTO: "PROFILE:SET_NOT_HAVE_PHOTO",
  SET_FB_ID: "PROFILE:SET_FB_ID",
  SET_GOOGLE_ID: "PROFILE:SET_GOOGLE_ID",
  SET_LINK_SOCIALS_ERR: "PROFILE:SET_LINK_SOCIALS_ERR",
  SET_PREV_ROUTE: "PROFILE:SET_PREV_ROUTE",
  SET_REASON_DELETING_PHOTO: "PROFILE:SET_REASON_DELETING_PHOTO",
  SET_ANONYMOUS_ME: "PROFILE:SET_ANONYMOUS_ME",
  SET_GESTURE_VERIFY_STATUS: "PROFILE:SET_GESTURE_VERIFY_STATUS",
  SET_PHOTO_REJECTED: "PROFILE:SET_PHOTO_REJECTED",
  SET_MAIN_PHOTO_REJECTED: "PROFILE:SET_MAIN_PHOTO_REJECTED",
  SET_VERIFIED_SUCCESS_MODAL: "PROFILE:SET_VERIFIED_SUCCESS_MODAL",
  SET_FEMALE_VERIFY_MODAL: "PROFILE:SET_FEMALE_VERIFY_MODAL",
};

export type profileDataType = {
  profile: {
    usePhone?: boolean;
    idFacebook: number;
    idGoogle: number;
    children?: boolean;
    relation: number;
    id: string;
    sex: genderType;
    name: string;
    birthday: string;
    phone: string;
    city: dataTypeForSelect;
    country: dataTypeForSelect;
    interest?: Array<dataTypeForSelect>;
    languages?: Array<dataTypeForSelect>;
    badHabits: {
      smoking?: string;
      alcohol?: string;
    };
    income?: string;
    occupation?: number;
    education?: string;
    aboutMe?: string;
    citizenship?: dataTypeForSelect;
    datingPurpose?: string;
    appearance: {
      hair?: string;
      eyes?: string;
      weight?: number;
      height?: number;
      breast?: number;
    };
    variabilityBirthday: boolean;
    variabilityName: boolean;
    sexPreference?: {
      sexualOrientation?: number;
      periodicity?: number;
      sexTypes?: Array<dataTypeForSelect>;
    };
  };
  photos: Array<onePhotoType>;
  isAnonymousProfile?: boolean;
  percentFillProfile?: number;
};

type onePhotoType = {
  photoUrl: {
    photoSmall: string;
    photoNormal: string;
    photoLarge: string;
    photoCropNormal?: string;
    photoCropSmall?: string;
  };
  photoInfo: {
    dateCreate: string;
    galleryType: galleryTypes;
    id: number;
    mainPhoto: boolean;
    name: string;
    profileOwnerId: string;
  };
};

export type profileProps = {
  name?: string;
  birthday?: string;
  city?: number;
  aboutMe?: string;
  income?: string;
  occupation?: number;
  languages?: Array<number>;
  nationality?: number;
  children?: boolean|"None";
  interest?: Array<number>;
  education?: string;
  smoking?: string;
  alcohol?: string;
  height?: number | string;
  weight?: number | string;
  hair?: string;
  eyes?: string;
  country?: number;
  datingPurpose?: string;
  citizenship?: number;
  relation?: number;
  sexualOrientation?: number;
  periodicity?: number;
  sexTypes?: Array<number>;
  breast?: number;
};

export const genderEnum = {
  Male: 0,
  Female: 1,
  NonBinary: 2,
};

export const genderEnumFromApi = {
  0: "Male",
  1: "Female",
  2: "NonBinary",
};

/** 0 — формулировки/списки как для мужчин, 1 — как для женщин (включая NonBinary). */
export function genderSelectIndex(gender: genderType): 0 | 1 {
  return gender === "Male" ? 0 : 1;
}

export type extendedProfileInfoResponseType = {
  countVisitors: number;
  countUnreadMessages: number;
  previewChats: Array<dialogType>;
  fillProfileGiftClaimed: boolean;
  previewProfile: {
    isAnonymousUser: boolean,
    mainPhoto: {
      photoLarge: string;
      photoNormal: string;
      photoSmall: string;
      photoCropNormal: string;
      photoCropSmall?: string;
    };
    onlineStatus: {
      online: boolean;
    };
    previewUserInfo: extendedProfileInfoType;
    /** 0 DONE, 1 NOT_VERIFIED (отказ), 2 WAIT (на проверке), 3 NOT_SUBMITTED */
    gestureVerificationStatus?: number;
    /** модерация главного фото: те же 0/1/2/3 */
    mainPhotoVerifiedStatus?: number;
  };
  profilePlaceInSearch: number;
  profileSex: 0 | 1 | 2;
};

export type extendedProfileInfoType = {
  birthday: string;
  sex: 0 | 1 | 2;
  city: dataTypeForSelect;
  country: dataTypeForSelect;
  id: string;
  name: string;
};

export const childrenSelect = [
  {
    id: "None",
    name: "entities.notSpecified",
  },
  {
    id: 0,
    name: "entities.have",
  },
  {
    id: 1,
    name: "entities.no",
  },
];
